let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("53SS8")).then(() => parcelRequire('cVpJX'));